export default "__VITE_ASSET__89d7a335__"